import { createUseStyles } from "react-jss";
import { breakpoints } from "../../../constants/breakpoints";
import {colors} from "../../../constants/colors";

const styles = createUseStyles({
  modalContent: {
    margin: "22px 0 0 0"
  },
  footerBtns: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "24px"
  },
  checkbox: {
    marginRight: "12px",
    cursor: "pointer"
  },
  modal: {
    width: "400px",
    "& .modal-header": {
      padding: "24px 24px 20px",
      "& div": {
        height: "46px",
        border: "none",
        padding: 0,
        "& svg": {
          display: "flex"
        }
      },
      "& button": {
        fontSize: "14px",
        position: "absolute",
        top: "32px",
        right: "32px"
      }
    },
    "& .modal-title": {
      padding: "0 24px"
    },
    "& .modal-body": {
      padding: "8px 24px",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px"
    },
    "& .modal-footer": {
      padding: "24px 24px"
    },
    "& .modal-footer>*": {
      margin: "0px"
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto"
    }
  },
  cancelBtn: {
    extend: "footerBtns",
    height: "100%",
    alignItems: "center",
  },
  cancelBtnCol: {
    paddingRight: "6px"
  },
  saveBtn: {
    extend: "footerBtns",
  },
  saveBtnCol: {
    paddingLeft: "6px"
  }
});

export default styles;